import React from 'react';
import ScreeningIndex from '../watch';

export default function () {
  return <ScreeningIndex replayOverride={true} bucketOverride="prevent" />;
}
